export default __webpack_public_path__ + "static/media/exit.12f8e176.svg";